<template>
  <el-popover
    :disabled="disabled"
    :width="width + 'px'"
    ref="popover"
    transition="el-zoom-in-top"
    placement="bottom-start"
    trigger="click"
  >
    <jc-tree
      :data="data"
      filterable
      @check="handleCheck"
      treeHeight="350px"
      :props="options"
      ref="tree"
      :default-expanded-keys="values"
      :empty-text="emptyText"
      :show-checkbox="true"
      :check-strictly="checkStrictly"
    />
    <div
      style="display: flex"
      class="el-input el-input--small tree-selector"
      :class="[
        { active: isVisible },
        {
          'is-error': error
        },
        { 'auto-height': height }
      ]"
      ref="content"
      :style="{ width: `${width}px` }"
      slot="reference"
    >
      <template v-if="formatValues && formatValues.length">
        <el-tag
          style="cursor: pointer"
          @click.native="isShow"
          :disable-transitions="true"
          size="small"
          :title="item.children.map(ii => ii[opts.label]).join('、')"
          v-for="item in formatValues"
          :key="item.id"
        >
          <span v-if="item.orgAbbreviationName"
            >{{ item.orgAbbreviationName }}/</span
          ><span>{{ item.children.length ? item.id + '：' : item.id }}</span
          ><span>{{ item.children.map(ii => ii[opts.label]).join('、') }}</span>
        </el-tag>
      </template>
      <span class="placeholder" v-else>{{ placeholder }}</span>
      <i
        class="el-icon-circle-close"
        v-if="clear && formatValues.length"
        @click.self="clearContent"
      ></i>
    </div>
  </el-popover>
</template>

<script>
import {
  addResizeListener,
  removeResizeListener
} from '@/utils/resize-manager.js'
export default {
  name: 'tree-selector',
  props: {
    size: {
      type: String,
      default: 'small'
    },
    width: {
      type: [String, Number],
      default: '450'
    },
    height: Boolean,
    disabled: {
      type: Boolean,
      default: false
    },
    value: {},
    data: {
      type: Array,
      default() {
        return []
      }
    },
    options: {},
    placeholder: {
      type: String,
      default: '请选择'
    },
    emptyText: {
      type: String,
      default: '没有查询到符合条件的结果'
    },
    clear: {
      // 显示清除按钮
      type: Boolean,
      default: true
    },
    error: [Boolean, String, Number], // 是否错误
    checkStrictly: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler() {
        if (this.value) this.init()
      }
    },
    options: {
      immediate: true,
      deep: true,
      handler() {
        if (this.options) {
          this.opts = Object.assign({}, this.opts, this.options)
        }
      }
    },
    data: {
      immediate: true,
      deep: true,
      handler() {
        if (this.data) this.init()
      }
    }
  },
  computed: {
    isVisible() {
      return this.popover && this.popover.showPopper
    }
  },
  data() {
    return {
      currentValue: [],
      values: [],
      formatValues: [],
      opts: {
        label: 'name',
        children: 'children',
        pid: 'pid'
      },
      popover: null
    }
  },
  methods: {
    handleCheck(node, state) {
      // 过滤掉上级分类
      let checkedNodes = state.checkedNodes
      this.currentValue = checkedNodes
      ///是否父子关联
      if (this.checkStrictly == false) {
        this.currentValue = checkedNodes.filter(
          item => !item[this.opts.children] || !item[this.opts.children].length
        )
      }
      this.$emit('input', this.currentValue)
    },
    /**
     * @description 初始化
     * @author yangyu
     */
    init() {
      this.$set(this, 'values', [])
      this.$set(this, 'formatValues', [])
      // 传入所有选中的对象
      this.currentValue = this.value
      this.values = this.value.map(val => val.id)
      this.formatValues = []
      // 合并相同父级的项 options.pid pid为0截止
      this.currentValue.forEach(val => {
        let pid = val[this.opts.pid]
        let lastNode = {}
        // 父级字符串
        let pStr = ''
        let pNode = this.findNode(this.data, pid)
        if (pNode) lastNode = pNode
        else lastNode = val
        while (pNode !== null && pid !== 0) {
          pStr = `${pNode[this.opts.label]}${pStr ? '/' + pStr : pStr}`
          pid = pNode[this.opts.pid]
          pNode = this.findNode(this.data, pid)
          if (pNode) lastNode = pNode
        }
        let single = false
        if (!pStr) {
          // 只有一级时
          pStr = lastNode[this.opts.label]
          single = true
        }
        // 是否存在该父级
        let index = this.formatValues.findIndex(f => {
          console.log(f, f.id === pStr)
          return f.id === pStr
        })
        if (val.orgAbbreviationName) {
          let newNode = {
            id: pStr,
            children: [],
            orgAbbreviationName: val.orgAbbreviationName
              ? val.orgAbbreviationName
              : ''
          }
          if (!single) newNode.children.push(val)
          this.formatValues.push(newNode)
        } else if (index === -1) {
          let newNode = {
            id: pStr,
            children: []
          }
          if (!single) newNode.children.push(val)
          this.formatValues.push(newNode)
        } else {
          if (!single) this.formatValues[index].children.push(val)
        }
      })
      this.$nextTick(() => {
        if (this.$refs.tree) this.$refs.tree.setCheckedKeys(this.values)
      })
    },
    /**
     * @description 递归获取节点
     */
    findNode(values, id) {
      if (!id || !values) return null
      for (let i = 0; i < values.length; ++i) {
        let child = values[i]
        if (child.id === id) return child
        let children =
          child[this.options.children ? this.options.children : 'children']
        if (children) {
          let node = this.findNode(children, id)
          if (node !== null) return node
        }
      }
      return null
    },
    handleResize() {
      if (this.$refs.popover) {
        this.$refs.popover.updatePopper()
      }
    },
    clearContent() {
      // 清除内容
      this.$emit('input', [])
      // this.$refs.tree.setCheckedKeys([])
    },
    isShow() {
      if (!this.$refs.popover.showPopper) {
        this.$nextTick(() => {
          this.$refs.popover.doShow()
        })
      } else {
        this.$nextTick(() => {
          this.$refs.popover.doClose()
        })
      }
    }
  },
  beforeDestroy() {
    this.$nextTick(() => {
      removeResizeListener(this.$refs.content, this.handleResize)
    })
  },
  mounted() {
    this.$nextTick(() => {
      this.popover = this.$refs.popover
      addResizeListener(this.$refs.content, this.handleResize)
    })
  }
}
</script>

<style lang="scss">
.tree-selector {
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  padding: 5px 5px 0;
  line-height: 1.1;
  min-height: 36px;
  overflow: hidden;
  outline: none;
  cursor: pointer;
  &:hover {
    border-color: #c0c4cc;
  }
  &.active {
    border-color: #409bff;
  }
  &.is-error {
    border-color: #f56c6c;
  }
  .el-input__suffix {
    cursor: pointer;
    z-index: 100;
  }
  .el-tag {
    margin-right: 4px;
    margin-bottom: 5px;
  }
  .placeholder {
    display: inline-block;
    color: #c0c4cc;
    font-size: 14px;
    line-height: 1;
    margin-top: 6px;
  }
  .el-icon-circle-close {
    display: none;
    position: absolute;
    right: 5px;
    z-index: 99;
    top: 10px;
    font-size: 16px;
    border-radius: 50%;
    font-weight: 600;
    // color: #C0C4CC;
    &:hover {
      opacity: 0.8;
      cursor: pointer;
    }
  }
  &:hover {
    .el-icon-circle-close {
      display: inline-block;
    }
  }
}
.auto-height {
  height: 36px;
}
</style>



// WEBPACK FOOTER //
// src/components/tree-selector/index.vue